export default "__VITE_PUBLIC_ASSET__954eac97__"